import React from 'react';
import HamburgerMenu from './HamburgerMenu';
import './Navigation.css';

function Navigation() {
  return (
    <nav className="app-navigation">
      <HamburgerMenu />
    </nav>
  );
}

export default Navigation;
